import type { FC, ReactNode } from 'react'

import { Calculator, Dices, KeyRound, UsersRound } from 'lucide-react'
import { SectionHeading } from '@/components/landing/section-heading'

const steps = [
    {
        icon: Calculator,
        title: 'Escolha o seu crédito',
        description: 'Defina o valor do bem e o prazo que cabe no orçamento. A simulação mostra a parcela na hora.'
    },
    {
        icon: UsersRound,
        title: 'Entre em um grupo',
        description: 'Você passa a pagar parcelas mensais junto com outros participantes, sem juros e sem entrada.'
    },
    {
        icon: Dices,
        title: 'Seja contemplado',
        description: 'Todo mês há assembleia com sorteio e lances. Ofertar um lance pode antecipar a sua vez.'
    },
    {
        icon: KeyRound,
        title: 'Compre à vista',
        description: 'Com a carta de crédito liberada, você negocia como quem tem dinheiro na mão e realiza a compra.'
    }
]

export const HowItWorksSection: FC = (): ReactNode => {
    return (
        <section
            id='como-funciona'
            aria-labelledby='como-funciona-titulo'
            className='border-y border-border bg-card/60 py-24 sm:py-32'
        >
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='como-funciona-titulo'
                    align='center'
                    eyebrow='Como funciona'
                    title='Quatro passos até a chave na mão'
                    description='O consórcio é uma compra planejada em grupo. Todo mês, participantes são contemplados e recebem o crédito para comprar à vista.'
                />

                <div className='relative mt-16'>
                    <div
                        aria-hidden='true'
                        className='absolute left-[12%] right-[12%] top-14 hidden border-t-2 border-dashed border-foreground/10 lg:block'
                    />

                    <ol className='relative grid gap-5 md:grid-cols-2 lg:grid-cols-4'>
                        {steps.map((step, index) => (
                            <li key={step.title} className='rounded-[1.5rem] bg-card p-7 shadow-xs ring-1 ring-border'>
                                <div className='flex items-center justify-between gap-4'>
                                    <span className='grid size-14 place-items-center rounded-2xl bg-ink text-gold'>
                                        <step.icon aria-hidden='true' className='size-6' />
                                    </span>

                                    <span aria-hidden='true' className='font-heading text-5xl leading-none text-foreground/15'>
                                        {String(index + 1).padStart(2, '0')}
                                    </span>
                                </div>

                                <h3 className='mt-8 text-xl font-bold text-foreground'>
                                    {step.title}
                                </h3>

                                <p className='mt-3 leading-relaxed text-muted-foreground'>
                                    {step.description}
                                </p>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    )
}
